<section class="dashboard">
  @if (loading()) {
    <div class="dashboard__state dashboard__state--loading">{{ 'dashboard.loading' | t }}</div>
  } @else if (error()) {
    <!-- Blocked case (e.g. active enforcement): notice plus contact only, no chat. -->
    @if (blocked() && caseHeader(); as header) {
      <div class="dashboard__meta" data-testid="dashboard-blocked-case-header">
        @if (header.aktenzeichen) {
          <span class="dashboard__meta-item">
            <span class="dashboard__meta-label">{{ 'dashboard.aktenzeichen' | t }}</span>
            <span class="dashboard__meta-value">{{ header.aktenzeichen }}</span>
          </span>
        }
        @if (header.aktenzeichen && header.glaeubiger) {
          <span class="dashboard__meta-divider" aria-hidden="true"></span>
        }
        @if (header.glaeubiger) {
          <span class="dashboard__meta-item">
            <span class="dashboard__meta-label">{{ 'dashboard.creditor' | t }}</span>
            <span class="dashboard__meta-value">{{ header.glaeubiger }}</span>
          </span>
        }
      </div>
    }
    <div class="dashboard__notice" role="alert">
      <span class="dashboard__notice-icon" aria-hidden="true">!</span>
      <div class="dashboard__notice-body">
        <strong class="dashboard__notice-title">{{ 'quickActionWizard.currentlyUnavailable' | t }}</strong>
        <p class="dashboard__notice-text">{{ blocked() ? ('dashboard.selfServiceBlocked' | t) : error() }}</p>
        <button type="button" class="dashboard__notice-action" data-testid="dashboard-blocked-contact" (click)="runQuickAction({ actionType: 'contact', contactCallbackExpanded: false })">
          {{ 'chat.actions.contactForm' | t }}
        </button>
      </div>
    </div>
  } @else {
    <div class="dashboard__banner">
      <div>
        <p class="dashboard__eyebrow">{{ 'dashboard.portal' | t }}</p>
        <h1 class="dashboard__title">{{ 'dashboard.headline' | t }}</h1>
      </div>
      <div class="dashboard__meta">
        <span class="dashboard__meta-item">
          <span class="dashboard__meta-label">{{ 'dashboard.aktenzeichen' | t }}</span>
          <span class="dashboard__meta-value">{{ dashboard().claim.aktenzeichen }}</span>
        </span>
        <span class="dashboard__meta-divider" aria-hidden="true"></span>
        <span class="dashboard__meta-item">
          <span class="dashboard__meta-label">{{ 'dashboard.creditor' | t }}</span>
          <span class="dashboard__meta-value">{{ dashboard().claim.creditorName }}</span>
        </span>
      </div>
    </div>

    <div class="dashboard__grid">
      <div class="dashboard__column dashboard__column--main">
        <app-claim-overview
          #claimOverview
          [claim]="dashboard().claim"
          (payNow)="runQuickAction({ actionType: 'payment', contactCallbackExpanded: false })">
        </app-claim-overview>

        <section class="dashboard__chat-card">
          <div class="dashboard__chat-frame" [style.--chat-height.px]="chatHeight()">
            <app-chat-widget
              #chatWidget
              (reloginRequired)="requireReLogin($event)"
              (claimDetails)="claimOverview.openDetails($event)"
              (quickAction)="runChatQuickAction($event)">
            </app-chat-widget>
          </div>
        </section>
      </div>

      <div class="dashboard__column dashboard__column--side">
        <app-quick-actions
          [permissions]="dashboard().permissions"
          (quickAction)="runQuickAction($event)">
        </app-quick-actions>

        <app-faq [items]="dashboard().faqItems"></app-faq>

        <app-feedback (reloginRequired)="requireReLogin($event)"></app-feedback>
      </div>
    </div>
  }

  @if (activeQuickAction(); as actionType) {
    <app-quick-action-wizard
      [actionType]="actionType"
      [paymentClaim]="{
        total: dashboard().claim.outstandingAmount,
        reference: dashboard().claim.aktenzeichen,
        creditor: dashboard().claim.creditorName
      }"
      [initialStep]="activeQuickActionInitialStep()"
      [initialStepPayload]="activeQuickActionInitialPayload()"
      [quickActionOrigin]="activeQuickActionOrigin()"
      [contactCallbackInitiallyExpanded]="activeContactCallbackExpanded()"
      (completed)="onQuickActionCompleted($event)"
      (close)="closeQuickAction()">
    </app-quick-action-wizard>
  }
</section>
